import React, { lazy } from 'react';
import { Route, Routes } from 'react-router-dom';
import contents from '../../routes/contentRoutes';
import { Navigate } from 'react-router-dom';

const ContentRoutes = () => {
	return (
		<Routes>
			{contents.map((page) => (
				<Route key={page.path} {...page} />
			))}
			<Route path='*' element={<Navigate to='/' replace />} />
		</Routes>
	);
};

export default ContentRoutes;
